
import React, { useState, ReactNode } from 'react'
import { useLocation, Navigate } from 'react-router-dom'
// import { navigate } from 'gatsby'
// hooks
import useAuth from '../hooks/useAuth'
// pages
// import Login from '../pages/authentication/ConnectWallet'
import { PATH_AUTH } from '../routes/paths'
import LoadingScreen from '../components/LoadingScreen'

// ----------------------------------------------------------------------

 type AuthGuardProps = {
  children: any
};

const LOCK_SITE = process.env.REACT_APP_LOCK_SITE as string

const AuthGuard:React.FC<AuthGuardProps> = ({ children }) => {
	const { isAuthenticated, isInitialized } = useAuth()
	// const { pathname } = useLocation()
	const location = useLocation()
	// console.log('location', location)
	// const [requestedLocation, setRequestedLocation] = useState<string | null>(null)

	// console.log('isInitialized', isInitialized)
	if (!isInitialized) {
		return <LoadingScreen />
	}

	// console.log('isAuthenticated', isAuthenticated)
	if (!isAuthenticated) {
		// navigate(PATH_AUTH.connectWallet, { replace: true })
		// Redirect them to the /login page, but save the current location they were
		// trying to go to when they were redirected. This allows us to send them
		// along to that page after they login, which is a nicer user experience
		// than dropping them off on the home page.
		return <Navigate to={PATH_AUTH.connectWallet} state={{ from: location }} replace />
		// return null
	}

	if (LOCK_SITE === 'true') {
		return <Navigate to="/coming-soon" replace />
	}

	return children
}
export default AuthGuard
/* export default function AuthGuard({ children }: AuthGuardProps) {
	const { isAuthenticated } = useAuth()
	const { pathname } = useLocation()
	const [requestedLocation, setRequestedLocation] = useState<string | null>(null)

	if (!isAuthenticated) {
		if (pathname !== requestedLocation) {
			setRequestedLocation(pathname)
		}
		return <Login />
	}

	if (requestedLocation && pathname !== requestedLocation) {
		setRequestedLocation(null)
		navigate(requestedLocation, { replace: true })
		return null
	}

	return <>{children}</>
} */
/*
const AuthGuard:React.FC<{component:any}> = ({ component: Component, ...rest }) => {
	const { isAuthenticated } = useAuth()
	const { pathname } = useLocation()
	const [requestedLocation, setRequestedLocation] = useState<string | null>(null)

	if (!isAuthenticated) {
		if (pathname !== requestedLocation) {
			setRequestedLocation(pathname)
		}
		return <Login />
	}

	if (requestedLocation && pathname !== requestedLocation) {
		setRequestedLocation(null)
		navigate(requestedLocation, { replace: true })
		return null
	}

	return <Component {...rest} />
}
*/
// export default AuthGuard
